import { PortableText } from '@portabletext/react'

import type { WheelItemsData, WheelItem } from '../wheelData'

import FeelingBadge from './FeelingBadge'

type DetailedDescriptionContentProps = {
  item: WheelItem
  wheelItemsData: WheelItemsData
}

export default function DetailedDescriptionContent({
  item,
  wheelItemsData,
}: DetailedDescriptionContentProps) {
  return (
    <>
      <Title item={item} wheelItemsData={wheelItemsData} />
      <article className="prose prose-ul:m-0 prose-p:mb-0 max-w-none">
        <PortableText value={wheelItemsData[item].description} />
      </article>
    </>
  )
}

function Title({ item, wheelItemsData }: DetailedDescriptionContentProps) {
  return (
    <div className="card-title flex flex-row items-center gap-2 pb-2">
      <FeelingBadge className="h-5 w-5" item={item} wheelItemsData={wheelItemsData} />
      <h2 className="text-2xl uppercase">{wheelItemsData[item].label.label}</h2>
    </div>
  )
}
